import { AllowedConnectorTypes } from './allowed-connector-types';
import { AllowedFormatTypes } from './allowed-format-types';
import { AllowedTaskTypes } from './allowed-task-types';
import { NodeTypes } from './node-types';

export const taskNodes = AllowedTaskTypes.map((type) => ({
  type,
  title: NodeTypes[type].title,
  node: 'task',
})).sort((a, b) => a.title.localeCompare(b.title));

export const formatNodes = AllowedFormatTypes.map((type) => ({
  type,
  title: NodeTypes[type].title,
  node: 'format',
})).sort((a, b) => a.title.localeCompare(b.title));
